import { Component, OnInit } from '@angular/core';
import { RestapiService } from 'src/app/services/restapi.service';
import { SeoService } from 'src/app/services/seo.service';
@Component({
  selector: 'app-game-main',
  templateUrl: './game-main.component.html',
  styleUrls: ['./game-main.component.scss']
})
export class GameMainComponent implements OnInit {

  public games;
  /*  public games = [
     {
       title: 'Incendios Forestales',
       legend: 'Conoce y aprende más sobre Incendios Forestales',
       img: '/assets/games/fuego-04.jpg',
       theme: 4,
       link: 'juego-inicio/incendios-forestales'
     },
     {
       title: 'Humedales',
       legend: 'Conoce y aprende más sobre Huemdales',
       theme: 4,
       img: '/assets/games/fuego-01.jpg',
       link: 'juego-inicio/humedales'
     },
     {
       title: 'Criaturas amazónicas',
       theme: 4,
       img: '/assets/games/fondo3.jpg',
       link: 'http://bufeo.wwfbolivia.org/'
     }
   ] */
  constructor(
    public seo: SeoService,
    public api: RestapiService
  ) {
    console.log('GAMES', this.games)
  }

  ngOnInit(): void {
    this.seo.generateTags({
      title: 'WWF Educación Ambiental, Conoce la naturaleza',
      description: 'Conoce la naturaleza',
      image: '/assets/brand.png',
      slug: window.location.href,
    });
    this.api.getdata('webcontext', {
      filters: {
        webroute_id: {
          value: 9
        }
      },
      orderBy: {
        field: 'id',
        direction: 'asc'
      }
    })
      .subscribe(res => {
        console.log('RUTAS DINÁMICAS', res);
        /* title: 'Incendios Forestales',
        legend: 'Conoce y aprende más sobre Incendios Forestales',
        img: '/assets/games/fuego-04.jpg',
        theme: 4,
        link: 'juego-inicio/incendios-forestales' */

        this.games = [];
        if (res.status == true) {
          res.result.data.forEach(e => {
            let x: any = {
              title: e.title?.es,
              legend: e.description ? e.description : 'Conoce más sobre ' + e.title?.es,
              img: this.api.getImageUrl(e.image),
              theme: '4',
              link: e.type == 1 ? e.name : 'juego-inicio/' + e.name,
            };
            this.games.push(x);
          });
          console.log('NEW GAMES ARRAY', this.games);
        }
        else {
          console.log('Error de carga')
        }


      })
  }

}
